import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  Tooltip,
  Bar,
  Cell,
} from "recharts";

import { Typography } from "clearsense-ui/components";

const Chart = ({ data }) => (
  <>
    <div className="flex-1 p-4 pb-0">
      <ResponsiveContainer>
        <BarChart data={data} barCategoryGap={0} barGap={0}>
          <XAxis dataKey="name" />
          <Tooltip cursor={{ fill: "rgba(200, 200, 200, 0.1)" }} />
          <Bar dataKey="value">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} {...entry.cellProps} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>

    <div className="flex w-full px-8 pb-6">
      {data.map((entry, index) => (
        <Typography
          key={`chart-percent-${index}`}
          className="flex-1 text-center"
        >
          {`${entry.percent} %`}
        </Typography>
      ))}
    </div>
  </>
);

export default Chart;
